import Auth from "../api/auth";
import { LocalStorageTokenStore } from "./TokenStore";

const auth = new Auth(new LocalStorageTokenStore());

export default auth;
